export default __webpack_public_path__ + "static/media/weather.45a4d565.png";